import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {useDispatch} from "react-redux";
import {requestDisbandClub} from "../../../../store/actionCreators/club";
import {useHistory} from "react-router-dom";

const DisbandClub =({clubId}) => {
  const { t } = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [id, setId] = useState('');
    const disbandClub = () => {
      dispatch(requestDisbandClub({clubId, history}));
    };
    return (
        <div className={`disbandClub`}>
            <div className={`disbandText`}>{t('disbandClub')}</div>
            <div className={`clubId`}>{t('clubId')}: {clubId}</div>
            <input type="number" placeholder={t('enterTheClubID')} onChange={ (e) => setId(e.target.value) }/>
            <div className={`dialogConfirmBox`}>
                <button className="primary" disabled = { id !== clubId } onClick={disbandClub}>{t('button.confirm')}</button>
            </div>
        </div>
    );
};

export default DisbandClub;
